<template>
  <div>
    <settings-section-title id="edit" class="i-mb-4"
      >View API Key</settings-section-title
    >
    <breadcrumbs :items="breadcrumbs"></breadcrumbs>

    <div
      v-if="hasEditPermissions"
      class="i-mt-12 view-form d-flex flex-column i-gap-9"
    >
      <i-text-input
        label="Name"
        :model-value="currentKey.name"
        :disabled="true"
      ></i-text-input>

      <i-text-input
        label="Description (optional)"
        :model-value="currentKey.description"
        :disabled="true"
        :mode="iTextInputModes.TEXTAREA"
      ></i-text-input>

      <div class="d-flex i-mt-6">
        <i-button
          text="Back"
          size="lg"
          type="neutral"
          subtype="subtle"
          @button-click="back()"
        ></i-button>
      </div>
    </div>

    <div v-else class="i-mt-12">
      <p>You must be an administrator to view this API key</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { iButton, iTextInput, iTextInputModes } from '@inscribe/signal';
import Breadcrumbs from '@/shared/components/Breadcrumbs';
import SettingsSectionTitle from '@/V2/settings/shared/SettingsSectionTitle';

export default {
  components: {
    Breadcrumbs,
    iButton,
    iTextInput,
    'settings-section-title': SettingsSectionTitle,
  },
  data() {
    return {
      iTextInputModes,
      apiKey: '',
      currentKey: {},
      breadcrumbs: [
        {
          text: 'Settings',
          to: { name: 'settings-view' },
        },
        {
          text: 'API Keys',
          to: { name: 'api-settings-list-keys' },
        },
        {
          text: 'View API Key',
          active: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasEditPermissions: 'isOrgAdmin',
    }),

    ...mapState(['currentUser']),
  },
  mounted() {
    this.apiKey = this.$route.params.api_key;
    this.currentKey = this.currentUser.organisation.api_keys.filter(
      (key) => key.key === this.apiKey,
    )[0];
  },
  methods: {
    back() {
      this.$router.push({
        name: 'api-settings-list-keys',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.view-form {
  max-width: 500px;
}
</style>
